import { ImageMetaData } from './validateImage';

export type ValidationRule = {
  expression(obj: File | ImageMetaData): boolean;
  getErrorMessage(obj: File | ImageMetaData): string;
};

export const validate = (file: File | ImageMetaData, rules: ValidationRule[]): string[] => {
  return rules.filter(rule => rule.expression(file)).map(rule => rule.getErrorMessage(file));
};

export const setCustomValidity = (ref: React.RefObject<HTMLInputElement | null>, error: string) => {
  if (ref?.current) {
    ref.current.setCustomValidity(error);
  }
};
